export default "__VITE_ASSET__Bq0c$e8u__"